module.exports = __webpack_public_path__ + "static/img/out10.57e81d50.png";